import {
  InMemoryHeader,
  InMemoryString
} from "pbas-vue-components";

export default [
  new InMemoryHeader({
    type: new InMemoryString("Identifier"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "headers.contacts.email",
    type: new InMemoryString("Email"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];